import React from "react";
import {
  Navbar,
  Collapse,
  Typography,
  IconButton,
  Button
} from "@material-tailwind/react";
 import logo from '../../images/logotourneedaccord.svg';
 import instalogo from '../../images/Instragram.svg';
export function StickyNavbar() {
  const [openNav, setOpenNav] = React.useState(false);
 
 
  const navList = (
    <ul className="flex flex-col my-4 lg:flex-row gap-3 lg:gap-6 z-20">
		<Typography as="li" variant="small">
			<a href="/#Claudia" className="flex text-[#4a4a4a] hover:text-[#0a0a0a] text-xl">Services &amp; Tarifs</a>
		</Typography>
		<Typography as="li" variant="small">
			<a href="/Contact" className="flex text-[#4a4a4a] hover:text-[#0a0a0a] text-xl">Contact</a>
		</Typography>
    </ul>
  );
 
  return (
<div className="w-full">
	<Navbar className="top-0 z-20 max-w-full w-full rounded-none px-8 py-2 fixed">
		<div className="flex items-center justify-between text-blue-gray-900">
			<div className="flex md:ml-4">
				<a href="/#"><img src={logo} className="w-12 h-auto md:mr-14" alt="logo" /></a>
			</div>
			{/*<span className="inline-flex items-center pt-2 font-Amiri text-[#877915] text-xl lg:text-5xl font-Amiri">La tournée d&apos;accord</span>}*/}
			<div className="flex items-center gap-6">
				<a href="https://www.instagram.com/la_tournee_d_accord?igsh=MTZyMWxwbzdlZXRuaQ==dre" target="_blank" rel="noopener noreferrer">
					<img src={instalogo} alt="Instagram" className="w-6 h-6 hover:opacity-80 transition-opacity"/>
				</a>
				<div className="hidden lg:inline-flex">{navList}</div>
				<a href="/ContactForm"><Button className="bg-[#a07b59] px-2 md:px-5 text-xs md:text-sm">Programmer un RDV</Button></a>
				<IconButton variant="text" className="ml-auto h-6 w-6 text-inherit focus:bg-transparent active:bg-transparent lg:hidden" ripple={false} onClick={()=> setOpenNav(!openNav)}>
				{openNav ? (
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" className="h-6 w-6" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
						<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
					</svg>
				) : (
					<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth={2}>
						<path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
					</svg>
				)}
				</IconButton>
			</div>
		</div>
		<Collapse className="ml-4 z-20" open={openNav}>{navList}</Collapse>
	</Navbar>
	<div className="navbarseparator mb-20"></div>
</div> 
  );
}

export default StickyNavbar;
